import BookACallButton from '../Buttons/Specials/BookACallButton'
import { ContainerWrapper } from '../Container'
import HomepageBookCallLeadModal from '../Modals/HomepageBookCallLeadModal'

const BETTER_DIRECT_MAIL_MODAL_PROPS = {
    formName: 'Better Direct Mail Strategy Call',
}

const DeviceMock = ({ src, alt }) => (
    <div className="relative w-full max-w-[520px]">
        <img src={src} alt={alt} className="block w-full h-auto object-cover" />
    </div>
)

function NumberedItem({ index, label, text }) {
    return (
        <div className="flex gap-4 items-start">
            <div className="text-[#ED5C2F] font-semibold text-xl md:text-3xl leading-none pt-1">
                {index}.
            </div>
            <div className="text-black text-lg ">
                <span className="font-bold text-black">{label} -</span>
                <span> </span>
                <span className="font-medium">{text}</span>
            </div>
        </div>
    )
}

export default function FreeCallKeySection({
    heading = 'Why This Free Call Could Be the Key to Your Next Deal',
    description = 'This isn’t just a consultation — it’s a strategy session to give you clarity on where to focus, how to scale, and how to close more deals. You’ll leave with practical steps tailored to your market.',
    imageSrc = ' /assets/real-estate-postcards/free-call-ROI.webp',
    imageAlt = 'Strategy call illustration',
    points = [
        {
            label: 'Market Evaluation',
            text: 'Spot motivated sellers and common roadblocks in your area.',
        },
        {
            label: 'Tech Enhancements',
            text: 'Simple tools (call tracking, CRM, automation) to save time and boost results.',
        },
        {
            label: 'Mailer Strategy',
            text: 'Discover which postcard designs and headlines drive the most calls.',
        },
        {
            label: 'Performance Review',
            text: 'Quick audit of past efforts with tweaks for higher ROI and scalability.',
        },
        {
            label: 'List-Building Guidance',
            text: 'Learn high-converting segments: absentee owners, vacants, preforeclosures, and more.',
        },
        {
            label: 'Free Resources',
            text: 'Scripts, contracts, checklists + 1,500 free leads to kickstart your next campaign.',
        },
    ],
}) {
    return (
        <section
            aria-labelledby="free-call-heading"
            className="py-16 relative overflow-hidden rounded-3xl md:rounded-[56px] bg-[radial-gradient(at_center_center,#FFF8EA00_0%,#FFF8E9_100%)]">
            <img
                src="/assets/real-estate-postcards/call-action-left-1.webp"
                alt=""
                className="absolute left-0 top-[calc(50%-100px)] hidden xl:block"
            />
            <img
                src="/assets/real-estate-postcards/green-card.webp"
                alt=""
                className="absolute left-0 bottom-[calc(50%-450px)] hidden xl:block"
            />

            <img
                src="/assets/real-estate-postcards/envelope-right.webp"
                alt=""
                className="absolute right-0 top-[calc(50%-150px)] z-10 hidden xl:block"
            />
            <img
                src="/assets/real-estate-postcards/call-action-right.webp"
                alt=""
                className="absolute right-0 bottom-[calc(50%-400px)] hidden xl:block"
            />

            <ContainerWrapper footer={false}>
                {/* Rounded gradient block */}
                <div className="max-w-6xl px-2 mx-auto">
                    <div className="relative px-3 lg:px-10 py-0">
                        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-10 items-center">
                            {/* Left visual */}
                            <div className="lg:col-span-6 md:col-span-5 hidden md:block">
                                <div className="relative">
                                    <DeviceMock src={imageSrc} alt={imageAlt} />
                                </div>
                            </div>

                            {/* Right content */}
                            <div className="lg:col-span-6 md:col-span-7">
                                <h2
                                    id="free-call-heading"
                                    className="text-3xl md:text-5xl font-bold text-[#ED5C2F] text-center md:text-left">
                                    {heading}
                                </h2>
                                <p className="mt-4 text-black font-normal text-lg text-center md:text-left">
                                    {description}
                                </p>
                            </div>
                            <div className="lg:col-span-6 md:col-span-5 block md:hidden">
                                <div className="relative">
                                    <DeviceMock src={imageSrc} alt={imageAlt} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="max-w-[90%] lg:max-w-5xl mx-auto">
                    {/* Numbered items below the block */}
                    {Array.isArray(points) && points.length > 0 && (
                        <div className="mt-10 md:mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
                            {points.map((p, idx) => (
                                <NumberedItem
                                    key={idx}
                                    index={idx + 1}
                                    label={p.label}
                                    text={p.text}
                                />
                            ))}
                        </div>
                    )}
                </div>

                <div className="max-w-xs mx-auto mt-8">
                    <BookACallButton
                        Modal={HomepageBookCallLeadModal}
                        modalProps={BETTER_DIRECT_MAIL_MODAL_PROPS}>
                        Book My Free Strategy Call
                    </BookACallButton>
                </div>
            </ContainerWrapper>
        </section>
    )
}
